import styled from 'styled-components'

export const Wrapper = styled.div<{ $focused?: boolean }>`
  width: 100%;
  background-color: #EBEBEB;
  border-radius: 16px;
  border: 1px solid ${({ $focused }) => ($focused ? '#0090D3' : 'transparent')};
  overflow: hidden;
  transition: border-color 0.15s ease;
`

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px;
  padding: 6px 8px;
  border-bottom: 1px solid #dcdcdc;
`

export const ToolbarButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ $active }) => ($active ? '#d6d6d6' : 'transparent')};
  color: #303030;

  &:hover {
    background-color: #dedede;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const ToolbarDivider = styled.div`
  width: 1px;
  height: 20px;
  background-color: #d3d3d3;
  margin: 0 4px;
`

export const EditorArea = styled.div`
  padding: 12px 16px;
  min-height: 100px;
  max-height: 320px;
  overflow-y: auto;
  font-size: 14px;
  color: #303030;
  font-family: inherit;

  .ProseMirror {
    outline: none;
    min-height: 76px;
  }

  .ProseMirror p {
    margin: 0 0 8px;
  }

  .ProseMirror p:last-child {
    margin-bottom: 0;
  }

  .ProseMirror ul,
  .ProseMirror ol {
    margin: 0 0 8px;
    padding-left: 22px;
  }

  .ProseMirror blockquote {
    margin: 0 0 8px;
    padding-left: 12px;
    border-left: 3px solid #b7b7b7;
    color: #555;
  }

  .ProseMirror a {
    color: #0090D3;
    text-decoration: underline;
  }

  .ProseMirror p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    float: left;
    height: 0;
    color: #999;
    pointer-events: none;
  }
`
